import { Overlay } from "../../../OddsCalc/styles";
import { CancelWrapper } from "../../styled";
interface ReservationCancelPopupProps {
  onClose: () => void;
  handleCancel: () => void;
}
const ReservationCancelPopup = ({
  onClose,
  handleCancel,
}: ReservationCancelPopupProps) => {
  return (
    <>
      <CancelWrapper>
        <div className="title">해당 토너먼트 예약을 취소하시겠습니까?</div>
        <div className="button-wrapper">
          <div className="button" onClick={() => onClose()}>
            닫기
          </div>
          <div className="button red" onClick={() => handleCancel()}>
            확인
          </div>
        </div>
      </CancelWrapper>
      <Overlay />
    </>
  );
};

export default ReservationCancelPopup;
